export default function swiper() {
  const swiperAnimation = new SwiperAnimation()

  let swiperHomeEmpreendimentos = new Swiper('.slide-home-empreendimentos', {
    effect: 'coverflow',
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    speed: 1000,
    loop: true,
    fadeEffect: {
      crossFade: true
    },
    grabCursor: true,
    spaceBetween: 16,
    preventInteractionOnTransition: false,
    /* navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }, */

    on: {
      init: function () {
        swiperAnimation.init(this).animate()
      },
      slideChange: function () {
        swiperAnimation.init(this).animate()
      }
    }
  })




  let swiperHomePortfolio = new Swiper('.slide-home-portfolio', {
    effect: 'slide',
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    speed: 1000,
    preventInteractionOnTransition: false,
    slidesPerView: 3,
    spaceBetween: 16,
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
  })




  let swiperEmpreendimentos = new Swiper('.slide-empreendimentos-hero', {
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    speed: 1000,
    preventInteractionOnTransition: false,
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })






  let swiperVirtualEnvironmentParent = new Swiper('.swiper-nested', {
    effect: 'coverflow',
    pagination: '.swiper-nested',
    speed: 1000,
    noSwiping: true,
    noSwipingClass: 'swiper-slide',
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-nested .swiper-button-next',
      prevEl: '.swiper-nested .swiper-button-prev',
    },
  })

  let swiperVirtualEnvironment = new Swiper('.virtual-env', {
    effect: 'slide',
    pagination: '.virtual-env',
    speed: 1000,
    slidesPerView: 1,
    autoplay: {
      delay: 6000,
    },
    nested: true
  })





  let swiperPlantas = new Swiper('.slider-plantas', {
    effect: 'slide',
    pagination: '.slider-plantas',
    speed: 1000,
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-plantas-button-next',
      prevEl: '.swiper-plantas-button-prev',
    },
  })




  const $depoimentos = document.querySelector('.slider-depoimentos');
  let depoimentosCount = $depoimentos && Number($depoimentos.dataset.count);

  let swiperDepoimentos = new Swiper('.slider-depoimentos', {
    effect: 'slide',
    pagination: '.slider-depoimentos',
    speed: 300,
    loop: depoimentosCount > 3 ? true : false,
    slidesPerView: 1,
    spaceBetween: 16,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 3,
      }
    },
    navigation: {
      nextEl: '.slider-depoimentos-button-next',
      prevEl: '.slider-depoimentos-button-prev',
    },
  })
}
